export enum StorageType {
  STORAGE_TYPE_UNSPECIFIED = 'STORAGE_TYPE_UNSPECIFIED',
  STORAGE_TYPE_S3 = 'STORAGE_TYPE_S3',
  STORAGE_TYPE_GCS = 'STORAGE_TYPE_GCS',
  STORAGE_TYPE_AZURE_BLOB = 'STORAGE_TYPE_AZURE_BLOB',
  STORAGE_TYPE_SFTP = 'STORAGE_TYPE_SFTP',
  STORAGE_TYPE_FTP = 'STORAGE_TYPE_FTP',
  STORAGE_TYPE_LOCAL = 'STORAGE_TYPE_LOCAL',
}

export enum ConnectivityState {
  CONNECTIVITY_STATE_UNSPECIFIED = 'CONNECTIVITY_STATE_UNSPECIFIED',
  CONNECTIVITY_STATE_CONNECTED = 'CONNECTIVITY_STATE_CONNECTED',
  CONNECTIVITY_STATE_DISCONNECTED = 'CONNECTIVITY_STATE_DISCONNECTED',
  CONNECTIVITY_STATE_UNTESTED = 'CONNECTIVITY_STATE_UNTESTED',
}

export enum DeliveryState {
  DELIVERY_STATE_UNSPECIFIED = 'DELIVERY_STATE_UNSPECIFIED',
  DELIVERY_STATE_PENDING = 'DELIVERY_STATE_PENDING',
  DELIVERY_STATE_RUNNING = 'DELIVERY_STATE_RUNNING',
  DELIVERY_STATE_SUCCEEDED = 'DELIVERY_STATE_SUCCEEDED',
  DELIVERY_STATE_FAILED = 'DELIVERY_STATE_FAILED',
  DELIVERY_STATE_CANCELLED = 'DELIVERY_STATE_CANCELLED',
}

export enum ScheduledDeliveryState {
  SCHEDULED_DELIVERY_STATE_UNSPECIFIED = 'SCHEDULED_DELIVERY_STATE_UNSPECIFIED',
  SCHEDULED_DELIVERY_STATE_ACTIVE = 'SCHEDULED_DELIVERY_STATE_ACTIVE',
  SCHEDULED_DELIVERY_STATE_PAUSED = 'SCHEDULED_DELIVERY_STATE_PAUSED',
  SCHEDULED_DELIVERY_STATE_CANCELLED = 'SCHEDULED_DELIVERY_STATE_CANCELLED',
}

export enum CredentialType {
  CREDENTIAL_TYPE_UNSPECIFIED = 'CREDENTIAL_TYPE_UNSPECIFIED',
  CREDENTIAL_TYPE_SSH = 'CREDENTIAL_TYPE_SSH',
  CREDENTIAL_TYPE_AWS = 'CREDENTIAL_TYPE_AWS',
  CREDENTIAL_TYPE_GCP_SERVICE_ACCOUNT = 'CREDENTIAL_TYPE_GCP_SERVICE_ACCOUNT',
  CREDENTIAL_TYPE_AZURE_SERVICE_PRINCIPAL = 'CREDENTIAL_TYPE_AZURE_SERVICE_PRINCIPAL',
}

export enum ScheduleType {
  SCHEDULE_TYPE_UNSPECIFIED = 'SCHEDULE_TYPE_UNSPECIFIED',
  SCHEDULE_TYPE_CRON = 'SCHEDULE_TYPE_CRON',
  SCHEDULE_TYPE_RATE = 'SCHEDULE_TYPE_RATE',
  SCHEDULE_TYPE_FIXED_TIME = 'SCHEDULE_TYPE_FIXED_TIME',
}

export enum ArchiveAction {
  ARCHIVE_ACTION_UNSPECIFIED = 'ARCHIVE_ACTION_UNSPECIFIED',
  ARCHIVE_ACTION_MOVE = 'ARCHIVE_ACTION_MOVE',
  ARCHIVE_ACTION_DELETE = 'ARCHIVE_ACTION_DELETE',
}

export enum ExecutionMode {
  EXECUTION_MODE_UNSPECIFIED = 'EXECUTION_MODE_UNSPECIFIED',
  EXECUTION_MODE_SYNC = 'EXECUTION_MODE_SYNC',
  EXECUTION_MODE_ASYNC = 'EXECUTION_MODE_ASYNC',
}

export interface ApiContext {
  datacenter: string;
  serviceAccount: string;
}

export interface PaginationParams {
  pageSize?: number;
  pageToken?: string;
  filter?: string;
  orderBy?: string;
}

export interface PaginatedResponse<T> {
  items: T[];
  nextPageToken?: string;
  totalSize: number;
}

export interface Schedule {
  type: ScheduleType;
  expression: string;
  timezone?: string;
}

export interface PreDeliveryAction {
  action: ArchiveAction;
  archivePath?: string;
}

export interface PostDeliveryAction {
  action: ArchiveAction;
  archivePath?: string;
}

export interface RetryConfig {
  maxAttempts: number;
  initialDelay?: string;
  maxDelay?: string;
  backoffMultiplier?: number;
}

export interface FileTransfer {
  sourceUri: string;
  targetUri: string;
  sizeBytes: number;
  success: boolean;
  errorMessage?: string;
}

export const simulateLatency = (minMs = 300, maxMs = 800): Promise<void> => {
  const delay = Math.floor(Math.random() * (maxMs - minMs + 1)) + minMs;
  return new Promise((resolve) => setTimeout(resolve, delay));
};
